import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { EResource } from '../../types/departamento';
import { ERevisionStatus } from '../../types/miRecurso';

interface IRevisionRecursosPage {
	searchQuery: string;
	selectedFileType: EResource | 'all';
	selectedStatus: ERevisionStatus | 'all';
	selectedMateria: number | 'all';
	dateRange: string;
}

const initialState: IRevisionRecursosPage = {
	searchQuery: '',
	selectedFileType: 'all',
	selectedStatus: 'all',
	selectedMateria: 'all',
	dateRange: 'últimos-30-días',
};

export const revisionRecursosPageSlice = createSlice({
	name: 'revisionRecursosPage',
	initialState,
	reducers: {
		setSearchQuery: (state, action: PayloadAction<string>) => {
			state.searchQuery = action.payload;
		},
		setSelectedFileType: (state, action: PayloadAction<EResource | 'all'>) => {
			state.selectedFileType = action.payload;
		},
		setSelectedStatus: (state, action: PayloadAction<ERevisionStatus | 'all'>) => {
			state.selectedStatus = action.payload;
		},
		setSelectedMateria: (state, action: PayloadAction<number | 'all'>) => {
			state.selectedMateria = action.payload;
		},
		setDateRange: (state, action: PayloadAction<string>) => {
			state.dateRange = action.payload;
		},
		resetFilters: (state) => {
			state.searchQuery = '';
			state.selectedFileType = 'all';
			state.selectedStatus = 'all';
			state.selectedMateria = 'all';
			state.dateRange = 'últimos-30-días';
		},
		resetRevisionRecursosPage: () => initialState,
	},
});

export const {
	setSearchQuery,
	setSelectedFileType,
	setSelectedStatus,
	setSelectedMateria,
	setDateRange,
	resetFilters,
	resetRevisionRecursosPage,
} = revisionRecursosPageSlice.actions;

export default revisionRecursosPageSlice.reducer;
